import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { getStudyPlansTransition } from "../../transitionalStates/getStudyPlansTransition"
import {
  Context,
  PlansOverviewSchema,
  StudyPlanTargets,
  Transitions
} from "../../types"
import {
  getAdminRelevantPlanInfoTransition,
  getGlobalSettingsTransition,
  saveGlobalPlanSettingsTransition
} from "./transitionalStates"
import {
  getReviewPlanRedirect,
  setRedirectUrl
} from "../../actions/setRedirectUrl"

export const studyPlansOverview: StateNodeConfig<
  Context,
  PlansOverviewSchema,
  Transitions,
  BaseActionObject
> = {
  id: "study_plans_overview",
  entry: [
    assign((ctx, evt, meta) => {
      if (ctx.previousParentState !== "study_plans_overview") {
        return setRedirectUrl(ctx, evt, meta, StudyPlanTargets.Overview)
      }
    }),
    assign((_ctx, _evt) => {
      return {
        previousParentState: "study_plans_overview",
        currentTarget: StudyPlanTargets.Overview
      }
    })
  ],

  initial: "loading",
  states: {
    loading: { ...getStudyPlansTransition },
    get_global_settings: {
      ...getGlobalSettingsTransition
    },
    get_admin_relevant_plan_info_transition: {
      ...getAdminRelevantPlanInfoTransition
    },
    save_global_plan_settings: { ...saveGlobalPlanSettingsTransition },
    idle: {
      on: {
        // after subject is selected, fetch relevant plan info
        GET_GLOBAL_SETTINGS: {
          target: "get_global_settings",
          actions: assign<Context>({
            viewGlobalSettings: true,
            subject: null
          })
        },
        EDIT: {
          target: "#StudyPlan.fetch_study_plan_transition",
          actions: assign((_ctx, { selectedPlanId }) => ({
            selectedPlanId: selectedPlanId
          }))
        },
        FETCH_PLAN_BY_REF_SCOPE: {
          target: "#StudyPlan.get_current_plan",
          actions: assign((ctx, _evt) => ({
            currentTarget: StudyPlanTargets.ReviewPlan,
            ...getReviewPlanRedirect(ctx)
          }))
        },
        SUBJECT_CLASS_ASSIGNMENT: {
          // target: "#StudyPlan.subject_class_assignment"
          // actions: // TODO: redirect user to subject class assignment url
        },
        SAVE_GLOBAL_PLAN_SETTINGS: {
          target: "save_global_plan_settings"
        }
      }
    }
  },
  on: {
    SELECT_SUBJECT: [
      {
        target:
          "#StudyPlan.study_plans_overview.get_admin_relevant_plan_info_transition",
        actions: assign((_ctx, { newSubject }) => {
          return {
            subject: newSubject,
            viewGlobalSettings: false
          }
        }),
        cond: ctx => {
          return (
            ctx.studyPlansListBySubjects &&
            Object.keys(ctx.studyPlansListBySubjects).includes(ctx.subject)
          )
        }
      },
      {
        target: "#StudyPlan.study_plans_overview",
        actions: assign((_ctx, { newSubject }) => {
          return {
            subject: newSubject,
            viewGlobalSettings: false
          }
        })
      }
    ]
  }
}
